import axios from "axios";

const API_BASE_URL = "https://api.jshmcsl.com/api/members";

// http://localhost:4000
// https://api.jshmcsl.com
export const registerMember = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/register`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Member registration failed:", error);
    throw error.response?.data || error;
  }
};

// Get all members
export const getAllMembers = async () => {
  try {
    const response = await axios.get(API_BASE_URL);
    return response.data;
  } catch (error) {
    console.error("Fetching members failed:", error);
    throw error.response?.data || error;
  }
};

export const getRegisteredMembers = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/registered-members`);
    return res.data.data;
  } catch (error) {
    console.error("Failed to fetch members:", error);
    throw error;
  }
};

export const updateMemberStatus = async (memberId, status, no_of_shares) => {
  const res = await axios.put(`${API_BASE_URL}/update-status`, {
    memberId,
    status,
    no_of_shares,  
  });
  return res.data;
};


export const fetchLastMembershipId = async () => {
  const res = await fetch("/api/members/last-id");
  return res.json();
};
